export default {
    waypointNo: 'Waypoint No',
    addAction: 'Add Action',
    saveAction: 'Save Action',
    waitForCompletion: 'Wait for completion',
    PTZAction: 'PTZ action',
    PTZTilt: 'Tilt angle of PTZ',
    PTZHeading: 'Heading angle of PTZ',
    PTZModeSwitch: 'PTZ mode switch',
    PTZHeadFollows: 'PTZ head follows',
    PTZPositionKeeping: 'PTZ position keeping',
    cameraAction: 'Camera action',
    photograph: 'Photograph',
    startRecording: 'Start recording',
    endRecording: 'End recording',
    zoom: 'Zoom',
    isochronousPhotography: 'Isochronous photography',
    isometricPhotography: 'Isometric photography',
    endTakingPictures: 'End taking pictures',
    pagerAction: 'Pager action',
    pagerStartsPlaying: 'Pager starts playing',
    pagerStopsPlaying: 'Pager stops playing',
    throwerAction: 'Thrower action',
    throwerDisengaged: 'Thrower disengaged',
    waterPumpAction: 'Water pump action',
    waterPumpOn: 'Water pump on',
    waterPumpOff: 'Water pump off',
    audioFrequency: 'Audio',
    lifeDetectionAction: 'Life detection action',
    lifeDetectionBegins: 'Life detection begins',
    lifeDetectionEnd: 'Life detection end',
}